import React, { useEffect, useRef, useState, memo } from 'react';
import { Animated, TouchableOpacity, View, } from 'react-native';
import RNAnimated from 'react-native-reanimated';
import createStyleSheets from 'utils/createStyleSheets';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import Text from './Text';
import { rem } from './values';
import { isWeb } from '../constants';
const PADDING = rem(32);
export const Selector = ({ sections, onSelected, style, selectorStyle, selectedTextColor, unselectedTextColor, defaultIndex = 0, ...fontStyle }) => {
    const { paddingHorizontal, contentWidth } = useAppFrameDimensions(isWeb);
    const [selection, setSelection] = useState(defaultIndex);
    const [width, setWidth] = useState(contentWidth - paddingHorizontal * 2 - PADDING);
    const [itemWidth, setItemWidth] = useState((contentWidth - paddingHorizontal * 2 - PADDING - rem(8)) / sections.length);
    const left = useRef(new Animated.Value(itemWidth * selection)).current;
    const onLayout = (event) => {
        if (event.nativeEvent.layout.width) {
            setWidth(event.nativeEvent.layout.width);
        }
    };
    useEffect(() => {
        if (onSelected)
            onSelected(selection);
    }, [onSelected, selection]);
    useEffect(() => {
        setItemWidth((width - rem(8)) / sections.length);
    }, [sections, width]);
    const hasScrolled = useRef(false);
    useEffect(() => {
        const animation = Animated.timing(left, {
            toValue: itemWidth * selection,
            delay: 0,
            duration: hasScrolled.current ? 100 : 0,
            useNativeDriver: true,
        });
        animation.start(() => {
            hasScrolled.current = true;
        });
    }, [sections, selection, itemWidth, left]);
    const styles = useStyles(styleSet);
    const colors = useColors();
    return (<RNAnimated.View style={[styles.container, style]} onLayout={onLayout}>
      <Animated.View style={[
            styles.selector,
            selectorStyle,
            {
                width: itemWidth,
                transform: [
                    {
                        translateX: left,
                    },
                ],
            },
        ]}/>
      {sections.map((value, index) => index === selection ? (<View key={`${value}#${index * 2}`} style={[styles.item, { width: itemWidth }]}>
            <Text {...fontStyle} color={selectedTextColor || colors.text.textOnBrand}>
              {value}
            </Text>
          </View>) : (<TouchableOpacity key={`${value}#${index * 2}`} style={[styles.item, { width: itemWidth }]} onPress={() => setSelection(index)}>
            <Text {...fontStyle} color={unselectedTextColor || colors.text.secondary}>
              {value}
            </Text>
          </TouchableOpacity>))}
    </RNAnimated.View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        width: '100%',
        height: rem(44),
        borderRadius: rem(50),
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: colors.cards.onDark,
    },
    selector: {
        position: 'absolute',
        left: rem(4),
        height: rem(36),
        borderRadius: rem(50),
        backgroundColor: colors.buttons.brandLight,
    },
    item: {
        height: rem(36),
        borderRadius: rem(50),
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export default memo(Selector);
